module.exports = {
  "OEbranch": "master",
  "AIBase": "zh_cn",
  "filePath": "/src/i18n",
  "moduleName": "H5-soda-fe-b_c_i18n",
  "version": 0,
  "script": "//img0.didiglobal.com/static/copywriter_h5/H5-soda-fe-b_c_i18n/src/i18n/all.js",
  "noParse": true
}